import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    useTheme,
} from "@mui/material";

interface VideoErrorDialogProps {
    open: boolean;
    errorCode?: number;
    downloadFilename: string;
    onClose: () => void;
    onDownload?: () => void;
}

export const VideoErrorDialog: React.FC<VideoErrorDialogProps> = ({
    open,
    errorCode,
    onClose,
    onDownload,
}) => {
    const theme = useTheme();
    let message =
        "An error occurred while trying to play the video. You can download the video to watch it locally.";
    if (errorCode === 4) {
        message =
            "This video format (H.265/HEVC) is not supported in your browser. You can download the video to watch it locally.";
    }
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle
                sx={{ color: theme.palette.text.primary, textAlign: "center" }}
            >
                Video Unavailable
            </DialogTitle>
            <DialogContent>
                <Typography
                    variant="body1"
                    sx={{
                        color: theme.palette.text.secondary,
                        mb: 2,
                        textAlign: "center",
                    }}
                >
                    {message}
                </Typography>

                <Button
                    variant="contained"
                    color="primary"
                    component="a"
                    onClick={onDownload}
                    sx={{ width: "100%", mb: 1 }}
                >
                    Download Video
                </Button>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <Button onClick={onClose} variant="outlined">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
